<div class="map-content-component">
<div class="pt-4 pb-4 pl-md-5 pr-md-5 masthead bg-white">
    <div class="row align-items-center">
        <div class="col">
            <p class="mb-0 h3">
                <i class="fa mr-3 fa-map"></i>
                Map content
            </p>
        </div>
        <div class="col text-right ml-auto col-md-7 col-lg-6 col-xl-5">
                        <div class="dropdown-search-wrapper w-100" [class.open]="showDropdownOptions">
                                <ng-select
                                    [maxWidth]="'none'"
                                    [items]="filteredCountries"
                                    [active]="selectedCountry ? [selectedCountry] : []"
                                    [placeholder]="'Please select a location...'" 
                                    (selected)="selectCountry($event)"
                                    [searchable]="true"
                                    [showDefaultOption]="false"
                                    [allowClear]="true"
                                    (removed)="clearSelection()"
                                    (searchInput)="onSearchInput($event)"
                                    (focus)="onInputFocus()"
                                    (blur)="onInputBlur()"
                                    (click)="onInputClick()"
                                    (keydown)="onKeyDown($event)">
                                </ng-select>
                        </div>
        </div>
    </div>
</div>


<div class="container mt-5" *ngIf="selectedCountry">
    <div class="row">
        <div class="col">
            <div class="card" *ngIf="countryDashboardInformation">
                <div class="card-header bg-primary text-white">
                    <div class="row align-items-center">
                        <p class="h3 m-0 col">Manage map content</p>
                        <div class="col text-right">
                            <button type="submit" class="btn btn-outline-light btn-sm u-marginBottom--medium"
                                (click)="saveClicked();">
                                Publish changes <i class="fa fa-check ml-2"></i>
                            </button>
                            <button type="submit" class="btn btn-outline-light btn-sm u-marginBottom--medium"
                                (click)="saveClicked();showPublishModal()">
                                Publish and notify <i class="fa fa-check ml-2"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <p class="text-muted mb-3">Choose the key item and hover over text for {{selectedCountry.text}}</p>

                    <div *ngFor="let dropdown of countryDashboardInformation?.dropDownsToRender">
                        <fieldset class="form-group" *ngIf="dropdown?.presentationTypeId==1">
                            <label><strong>{{dropdown?.label}}</strong></label>
                            <ng-select
                              [items]="dropdown.dropDownItems"
                              [active]="dropdown.selectedDropDownItem ? [dropdown.selectedDropDownItem] : []"
                              [placeholder]="'Please select ' + (dropdown?.label || 'an option') + '...'" 
                              (selected)="selectDashboardItem($event, dropdown)">
                            </ng-select>
                        </fieldset>
                        <div *ngIf="dropdown?.presentationTypeId==2">
                            <dashboardkeys [dropdown]="dropdown" [countryId]="selectedCountry.id"
                                [dashboardInformation]="countryDashboardInformation"></dashboardkeys>
                        </div>
                    </div>

                </div>
            </div>

            <div class="alert alert-info" *ngIf="!countryDashboardInformation">
                <p><strong>Map content management unavailable</strong></p>
                To enable, please first configure this map's data hierarchy
            </div>
        </div>
    </div>
</div>

<confirmationmodal #confirmModal (onAccept)="onAccept();" (onDecline)="onDecline();"></confirmationmodal>
</div> <!-- End map-content-component wrapper -->
